module.exports = __webpack_public_path__ + "static/media/crowdOverhead.5b909098.jpg";